import PrivacySettingsLink from "./PrivacySettingsLink";
import languages from "./languages";
import { t } from "../i18n";
import { sendFooterLinkEvent } from "./analytics";
import { jsx as _jsx, jsxs as _jsxs } from "preact/compat/jsx-runtime";
const inlineLiClasses = 'hc-c-footer__inline-item';

/**
 * Inline link lists are always rendered in the footer, no matter
 * what type of page a user is looking at. It includes required
 * links, like the Privacy Policy, and other helpful things like
 * links to a variety of different languages.
 */
const InlineLinkLists = function (_ref) {
  let {
    primaryDomain = ''
  } = _ref;
  const inlineLinksTop = {
    'footer.contactUs': `${primaryDomain}/contact-us`,
    'footer.archive': `${primaryDomain}/archive`,
    'footer.a11y': 'http://www.cms.gov/About-CMS/Agency-Information/Aboutwebsite/CMSNondiscriminationNotice.html',
    'footer.privacySettings': /*#__PURE__*/_jsx(PrivacySettingsLink, {}),
    'footer.privacyPolicy': `${primaryDomain}/privacy`,
    'footer.usingThisSite': `${primaryDomain}/using-this-site`
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "ds-l-container",
    children: [/*#__PURE__*/_jsx("div", {
      className: "hc-c-footer__site-links-row",
      children: /*#__PURE__*/_jsx("ul", {
        role: "list",
        className: "hc-c-footer__list",
        children: Object.getOwnPropertyNames(inlineLinksTop).map(function (key, index) {
          const entry = inlineLinksTop[key];
          const isUrl = typeof entry === 'string';
          const linkText = t(key);
          const isLastItem = index !== Object.getOwnPropertyNames(inlineLinksTop).length - 1;
          return /*#__PURE__*/_jsxs("li", {
            className: inlineLiClasses,
            children: [isUrl ? /*#__PURE__*/_jsx("a", {
              href: entry,
              onClick: () => sendFooterLinkEvent(linkText, entry),
              children: linkText
            }) : entry, isLastItem ? /*#__PURE__*/_jsx("span", {
              "aria-hidden": "true",
              className: "hc-c-footer__delimiter"
            }) : null]
          }, key);
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "hc-c-footer__language-resource-links-row",
      children: [/*#__PURE__*/_jsx("p", {
        id: "hc-c-footer__language-resources",
        className: "ds-u-visibility--screen-reader",
        children: "Language resources"
      }), /*#__PURE__*/_jsx("ul", {
        role: "list",
        "aria-labelledby": "hc-c-footer__language-resources",
        className: "hc-c-footer__list",
        children: Object.getOwnPropertyNames(languages).map(function (lang) {
          const linkUrl = primaryDomain + languages[lang].href;
          const linkText = languages[lang].label;
          const handleClick = () => sendFooterLinkEvent(linkText, linkUrl, 'Language resources');
          return /*#__PURE__*/_jsx("li", {
            className: inlineLiClasses,
            onClick: handleClick,
            children: /*#__PURE__*/_jsx("a", {
              lang: lang,
              href: linkUrl,
              children: linkText
            })
          }, lang);
        })
      })]
    })]
  });
};
export default InlineLinkLists;